import { useMatch } from 'react-router';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import InternalErrorState from '@/features/app/InternalErrorState';
import { useFetchBatteryPackLevelsQuery } from '@/features/battery/api/batterySlice';
import PackLevelDetailView from '@/features/battery/workshop/PackLevelDetailView';
import { LoadingScreen } from '@/features/batteryOverview/utils/BatteryDataUtils';

const PackLevelDetailPage = () => {
    const match = useMatch('/dialog/pack-levels/:assetId/:packId');
    const assetId = match?.params.assetId;
    const packId = match?.params.packId;
    const { isLoading, isError, error, data: batteryPackResponse, refetch } = useFetchBatteryPackLevelsQuery(assetId!);

    if (isLoading) {
        return <LoadingScreen />;
    }
    if (isError) {
        return (
            <InternalErrorState
                errorCode={(error as FetchBaseQueryError).status as number}
                reloadTriggerFunction={refetch}
            />
        );
    }

    const pack = batteryPackResponse?.packs?.find((p) => p.id === packId);

    if (!pack) {
        return null;
    }

    return <PackLevelDetailView pack={pack} assetId={assetId!} batteryType={batteryPackResponse!.battery_type} />;
};

export default PackLevelDetailPage;
